import { createApp } from 'vue'
import ListingsMapApp from './ListingsMapApp.vue'

const app = createApp(ListingsMapApp, {
  filter: document.getElementById('listings-map-app')?.dataset.filter || 'all',
  isAuthenticated: document.getElementById('listings-map-app')?.dataset.isAuthenticated === 'true'
})

app.mount('#listings-map-app')